<div class="transport-registration-instructions">

    <ng-container *ngIf="instructionsForm">
        <form [formGroup]="instructionsForm" class="form" *ngIf="selectedInstruction == null">

            <div class="instructions-list">

                <div formArrayName="instructions" class="instruction"
                    *ngFor="let instruction of instructions; let i=index">
                    <div class="instruction-layout">
                        <div class="main-column">
                            <div class="title">
                                {{'' | translate: [instruction.titleDictionaryKey,
                                translationService.language]}}
                            </div>
                            <div class="description">
                                {{'' | translate: [instruction.descriptionDictionaryKey,
                                translationService.language]}}
                            </div>
                            <div class="checkbox">
                                <mat-checkbox formControlName="{{i}}">{{'' | translate:
                                    ['tmc-yard.widgets.registration-terminal.transport-registration-instructions.label.read',
                                    translationService.language]}}</mat-checkbox>
                            </div>
                            <p class="hint" *ngIf="instructions != null && instructions.length > 0">
                                <ng-container *ngIf="!instruction.checked">
                                    {{'Bestätigen Sie die Informationen' | translate:
                                    ['tmc-yard.widgets.registration-terminal.transport-registration-instructions.hint',
                                    translationService.language]}}
                                </ng-container>
                            </p>
                        </div>
                        <div class="right-column">
                            <div class="right-column-layout">

                                <div class="more action" (click)="showInstructionDetails(instruction)" matRipple>
                                    <div class="action-layout">
                                        <i class="fa-thin fa-file"></i>
                                        <div class="label">{{'Mehr anzeigen' |
                                            translate:
                                            ['tmc-yard.widgets.registration-terminal.transport-registration-instructions.label.showmore',
                                            translationService.language]}}</div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="instruction-separator">
                        <div class="instruction-separator-visual"></div>
                    </div>
                </div>
            </div>

        </form>
    </ng-container>

    <div class="instrution-details" *ngIf="selectedInstruction != null">
        <button mat-flat-button (click)="hideInstructionDetails()">
            <sc-icon iconClass="fa-chevron-left"></sc-icon>
        </button>
        <div class="title">{{'' | translate:[selectedInstruction.titleDictionaryKey, translationService.language]}}
        </div>
        <div class="content"
            [innerHTML]=" ''|translate:[selectedInstruction.textDictionaryKey, translationService.language]| trustHtml">
        </div>
    </div>

</div>